<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="2">
          <date-picker label="As of" v-model="date" date-only hide-details @change="refresh"/>
        </v-col>
        <v-col cols="3" v-if="sites.length>1">
          <v-autocomplete label="Site" dense outlined hide-details :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="siteId" item-text="name" item-value="id" @change="refresh()"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Physical inventory worksheet - tanks', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import {format} from 'date-fns'
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsInventoryTanksPhysical',
  mixins: [printHtml],
  data() {
    return {
      date: format(new Date(), 'yyyy-MM-dd'),
      siteId: null,
      tanks: []
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true);
    }
  },
  async created() {
    this.$emit('name', 'Physical inventory worksheet - Tanks')
    this.refresh();
  },
  methods: {
    async refresh() {
      this.tanks = [];
      this.$lazyListLoad(this.tanks, 'tanks2', `name,contents{volume,alcoholName,siteName}`, 100, this.siteId?[{field:'siteId', comparator:'eq', value:this.siteId}]:[], [{name:'asof', value:`${this.date} 23:59:59`}]);
    },

    report() {
    const lines = [
                  `<style>
                    @page {size:portrait}
                    .reports-physical-inventory {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .reports-physical-inventory th {height:36px;padding:0 16px;vertical-align:middle}
                    .reports-physical-inventory .spacer {height:18px}
                    .reports-physical-inventory td {height:36px;padding:0 16px;vertical-align:middle}
                    .reports-physical-inventory .title {font-size:18px;text-transform:uppercase}
                    .reports-physical-inventory .sup-title {font-weight:normal;font-size:22px}
                    .reports-physical-inventory .sub-title {font-weight:normal;margin-bottom:20px;font-size:14px}
                    .reports-physical-inventory .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .reports-physical-inventory .text-left {text-align:left}
                    .reports-physical-inventory .text-right {text-align:right}
                    .reports-physical-inventory .line {border-bottom:1px solid #000}
                  </style>
                  <table class="reports-physical-inventory">
                  <thead>
                    <tr>
                      <th colspan="8">
                        <div class="sup-title">${this.company.name}</div>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="8">
                        <div class="title">Physical inventory worksheet - Tanks</div>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="8">
                        <div class="sub-title">As of ${this.$formatDate(this.date)}</div>
                      </th>
                    </tr>
                    <tr class="header">
                      <th width="20%" class="text-left">Tank</th>
                      ${this.sites.length>1 && this.siteId==null ? '<th width="20%" class="text-left">Site</th>':''}
                      <th width="25%" class="text-left">Contents</th>
                      <th width="15%" class="text-right">Book volume</th>
                      <th width="5%"/>
                      <th width="15%" class="text-right">Physical volume</th>
                    </tr>
                  </thead>
                  <tbody>`
    ];
    for (const tank of this.tanks) {
      lines.push(`<tr>`);
      lines.push(`<td>${tank.name}</td>`);
      if (this.sites.length>1 && this.siteId==null)
        lines.push(`<td>${tank.contents.siteName}</td>`);
      lines.push(`<td>${tank.contents.alcoholName || ''}</td>`);
      lines.push(`<td class="text-right">${this.$number(tank.contents.volume,3)} LAA</td>`);
      lines.push(`<td/>`);
      lines.push(`<td class="line"></td>`);
      lines.push(`</tr>`);
    }
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },
    exportCSV() {
      const lines = [ `"${this.company.name}",,,,`,
                      `"Physical inventory worksheet - Tanks",,,,`,
                      `"As of ${this.$formatDate(this.date)}",,,,`,
                      `"Item","Site","Contents","Book volume","Physical volume"`
                    ];

      for (const tank of this.tanks)
        lines.push(`"${tank.name}","${this.sites.length>1 && this.siteId==null ? tank.contents.siteName : ''}","${tank.contents.alcoholName || ''}","${this.$number(tank.contents.volume,3)}",`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Physical inventory worksheet - Tanks.csv');
    }
  }
}
</script>